import React, { useState } from 'react'
import styles from './LbFAQs.module.css'
import { motion, AnimatePresence } from 'framer-motion'
import { FaChevronDown } from 'react-icons/fa'

const faqs = [
    {
        question: 'What is LeadBridge?',
        answer:
            'LeadBridge is a powerful form-to-CRM syncing tool that allows you to capture leads, enquiries, and appointments directly from your website into your CRM — instantly and securely.',
    },
    {
        question: 'How is LeadBridge integrated?',
        answer:
            'You can integrate LeadBridge via a single encrypted token, or by embedding a JavaScript snippet into your website. It auto-maps fields and syncs submissions in real-time.',
    },
    {
        question: 'Is LeadBridge free to use?',
        answer:
            'Yes! The Starter plan is included free for all CRM users. Paid plans offer extended features like analytics, routing, and domain flexibility.',
    },
    {
        question: 'Can I customize the form design?',
        answer:
            'Yes, LeadBridge is built to support both default and fully customized forms. You have complete control over styling and structure.',
    },
    {
        question: 'How secure is LeadBridge?',
        answer:
            'All form data is encrypted using industry-standard protocols and routed through secure APIs. Token-based authentication ensures only whitelisted sources can submit data.',
    },
]

const LbFAQs = () => {
    const [openIndex, setOpenIndex] = useState(null)

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }

    return (
        <section className={styles.faqSection}>
            <div className={styles.container}>
                <motion.h2
                    className={styles.heading}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    Frequently Asked Questions
                </motion.h2>

                <div className={styles.accordion}>
                    {faqs.map((faq, index) => (
                        <div key={index} className={styles.faqItem}>
                            <button
                                className={`${styles.question} ${openIndex === index ? styles.active : ''}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                {faq.question}
                                <FaChevronDown
                                    className={`${styles.icon} ${openIndex === index ? styles.rotate : ''}`}
                                />
                            </button>
                            <AnimatePresence initial={false}>
                                {openIndex === index && (
                                    <motion.div
                                        className={styles.answer}
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: 'auto', opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <p>{faq.answer}</p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default LbFAQs
